module.exports = __webpack_public_path__ + "img/arrows-left-right.3b03e0bc.svg";